// Copyright (c) Ping. All rights reserved.
//
// Mounts the settings walkthrough. Auto-starts once per user (gated on the
// `tour.settings.seen` flag) the first time the settings modal opens, and
// dismisses itself if the modal is closed part way through.

import { useMemo } from 'react';

import { useRouter } from '@shell/RouterContext';

import { GuidedTourHost } from './GuidedTour';
import { buildSettingsTourSteps } from './settingsTourSteps';
import { TOUR_SETTINGS } from './tourIds';

// Highest priority: it is user-initiated (they just opened settings).
const SETTINGS_TOUR_PRIORITY = 30;

export function SettingsTourHost(): JSX.Element {
  const router = useRouter();
  const modalOpen = router.modal.kind === 'settings';
  const steps = useMemo(() => buildSettingsTourSteps(), []);
  return (
    <GuidedTourHost
      tourId={TOUR_SETTINGS}
      steps={steps}
      priority={SETTINGS_TOUR_PRIORITY}
      enabled={modalOpen}
    />
  );
}
